import { inputStyles, labelStyles } from '../styles';
import { onChangeEventHandler, onMouseEventHandler } from '../../../util/eventHandlers';

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  id: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (
    e: React.MouseEvent<HTMLInputElement | HTMLButtonElement, MouseEvent>
  ) => void;
}

const Radio = ({
  label = '',
  name,
  id,
  disabled = false,
  onChange = () => {},
  onClick = () => {},
  ...props
}: RadioProps) => {
  return (
    <div className="ds-flex ds-h-4 ds-items-center">
      <input
        id={id}
        name={name}
        type="radio"
        className={`ds-form-radio ${inputStyles({ disabled })}`}
        aria-disabled={disabled}
        onChange={(e) => onChangeEventHandler(e, disabled, onChange)}
        onClick={(e) => onMouseEventHandler(e, disabled, onClick)}
        {...props}
      />
      <label htmlFor={id} className={labelStyles({ disabled })}>
        {label}
      </label>
    </div>
  );
};

export default Radio;
